export const NAVIGATION = {
  home: {
    slug: '/',
    title: 'Home',
    eventName: 'VIEW_GET_STARTED',
  },
  analytics: {
    slug: '/analytics',
    title: 'Analytics',
    eventName: 'VIEW_ANALYTICS',
  },
  dashboard: {
    slug: '/dashboard',
    title: 'Dashboard',
    seoName: 'Dashboard',
    eventName: 'VIEW_DASHBOARD',
  },
  login: {
    slug: '/login',
    title: 'Login',
    seoName: 'Login',
  },
  resetPassword: {
    slug: '/reset-password',
    title: 'Reset Password',
  },
  reviews: {
    slug: '/reviews',
    title: 'Reviews',
    seoName: 'Reviews',
    eventName: 'VIEW_REVIEWS',
  },
  developments: {
    slug: '/developments',
    title: 'Developments',
    seoName: 'Developments',
    eventName: 'VIEW_DEVELOPMENTS',
  },
  awards: {
    slug: '/awards',
    title: 'Awards',
    seoName: 'Awards',
    eventName: 'VIEW_AWARDS',
  },
  development: {
    slug: '/developments/:id',
    title: 'Development',
  },
  companies: {
    slug: '/companies',
    title: 'Companies',
    eventName: 'VIEW_COMPANIES',
  },
  media: {
    slug: '/media',
    title: 'Your Media',
    eventName: 'VIEW_MEDIA',
  },
  // brandMedia: {
  //   slug: '/brand-media',
  //   title: 'Brand Media'
  // },
  guides: {
    slug: '/guides',
    title: 'Guides',
    eventName: 'VIEW_GUIDES',
  },
  resources: {
    slug: '/resources',
    title: 'Your HomeViews Resources',
    eventName: 'VIEW_RESOURCES',
  },
  faq: {
    slug: '/faq',
    title: 'FAQ',
  },
  singleFaq: {
    slug: '/faq/:slug',
    title: 'FAQ',
  },
  widgets: {
    slug: '/widgets',
    title: 'Widgets',
    eventName: 'VIEW_WIDGETS',
  },
  createWidget: {
    slug: '/widgets/create',
    title: 'Create widget',
  },
  previewWidget: {
    slug: '/widgets/:id/preview',
    title: 'Preview Widgets',
  },
  users: {
    slug: '/users',
    title: 'Users',
    eventName: 'VIEW_USERS',
  },
  createUser: {
    slug: '/users/create',
    title: 'Create User',
  },
  editUser: {
    slug: '/edit-user/:id',
    title: 'Edit User',
  },
  editUserPermissions: {
    slug: '/edit-user/:id/permissions',
    title: 'Edit User Permission',
  },
  yourProfile: {
    slug: '/your-profile',
    title: 'Your Profile',
    eventName: 'VIEW_PROFILE',
  },
  outreachHome: {
    slug: '/outreach',
    title: 'Resident Email Tool',
    eventName: 'VIEW_RESIDENT_OUTREACH',
  },
  outreachCreate: {
    slug: '/outreach/:templateSlug',
  },
}

// Slugs a CompanyGroupAdmin is allowed to see and visit. The CompanyGroupAdmin
// experience is restricted to read-only oversight, so only the Dashboard and
// Reviews remain accessible. This allowlist drives both the sidebar navigation
// and the route-level guard, so any other (protected) route is hidden from the
// menu and redirects to the Dashboard on direct URL access.
export const COMPANY_GROUP_ADMIN_VISIBLE_SLUGS = [
  NAVIGATION.dashboard.slug,
  NAVIGATION.reviews.slug,
]

const conditionallyShowMenuItem = ({ condition, menuItem }) => {
  // The return of this function needs to be spread to
  if (condition) {
    return [menuItem]
  } else {
    return []
  }
}

// Legacy nav items hidden from users with `simplified_navigation` set in Athena
// (RVW-1718; replaces the RVW-1630 NX_HIDE_LEGACY_NAV_ITEMS env flag). Internal
// items are matched by slug; external links (which have no slug) by title.
export const LEGACY_NAV_IDENTIFIERS = new Set<string>([
  NAVIGATION.awards.slug,
  NAVIGATION.developments.slug,
  NAVIGATION.outreachHome.slug,
  NAVIGATION.companies.slug,
  NAVIGATION.media.slug,
  NAVIGATION.resources.slug,
  NAVIGATION.widgets.slug,
  NAVIGATION.guides.slug,
  'Partner Guides',
  'HomeViews Business Hub',
])

export const MAIN_MENU = [
  {
    ...NAVIGATION['dashboard'],
    icon: 'chart.svg',
    group: 'General',
  },
  {
    ...NAVIGATION['awards'],
    icon: 'award.svg',
    group: 'General',
  },
  {
    ...NAVIGATION['reviews'],
    icon: 'reviews.svg',
    group: 'General',
  },
  {
    ...NAVIGATION['developments'],
    icon: 'development.svg',
    group: 'General',
  },
  {
    ...NAVIGATION['outreachHome'],
    icon: 'community.svg',
    group: 'General',
  },
  {
    ...NAVIGATION['companies'],
    icon: 'company.svg',
    group: 'General',
  },
  {
    ...NAVIGATION['media'],
    icon: 'media.svg',
    group: 'Resources',
  },
  {
    ...NAVIGATION['resources'],
    icon: 'resources.svg',
    group: 'Resources',
  },
  // {
  //   ...NAVIGATION['brandMedia'],
  //   icon: 'media.svg',
  //   group: 'Resources'
  // },
  {
    ...NAVIGATION['widgets'],
    icon: 'widgets.svg',
    group: 'Resources',
  },
  {
    ...NAVIGATION['guides'],
    icon: 'guide.svg',
    group: 'Help & Support',
  },
  // {
  //   ...NAVIGATION['faq'],
  //   icon: 'guide.svg',
  //   group: 'Help & Support'
  // },
  {
    ...NAVIGATION['users'],
    icon: 'add-user.svg',
    group: 'Users',
  },
  {
    ...NAVIGATION['yourProfile'],
    icon: 'profile.svg',
    group: 'Users',
  },
  {
    title: 'Partner Guides',
    icon: 'blog.svg',
    group: 'Links',
    external: true,
    url: 'https://business.homeviews.com/knowledge-hub/',
    seoName: 'Partner Guides',
  },
  {
    title: 'HomeViews Business Hub',
    icon: 'insights.svg',
    external: true,
    group: 'Links',
    url: 'https://business.homeviews.com/resources',
    seoName: 'Business Hub',
  },
]
